import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material";

// Checks if an icon is a Material-UI OverridableComponent
export const isMUIIcon = (
  icon: unknown,
): icon is OverridableComponent<SvgIconTypeMap<object, "svg">> =>
  // Check if the icon is a function (React component)
  typeof icon === "function" && icon.prototype?.isReactComponent !== undefined;
